import { Dropdown } from "@freightsimple/ui-core/Controls/Dropdown";
import { claimsFieldWidth } from "../Helpers/claimsFieldWidth";
import { FreightClaimRepairability } from "@freightsimple/generated-dashboard-openapi-client/models/FreightClaimRepairability";

function describeRepairability(value: FreightClaimRepairability): string {
  switch (value) {
    case FreightClaimRepairability.Repairable:
      return "Repairable";
    case FreightClaimRepairability.NotRepairable:
      return "Not Repairable";
    case FreightClaimRepairability.Unknown:
      return "Unknown";
  }
}

interface ItemRepairabilityDropdownProps {
  repairability: FreightClaimRepairability;
  setRepairability: (_: FreightClaimRepairability) => void;
  id?: string | undefined;
}

const repairabilityOptions = Object.values(FreightClaimRepairability).map(
  (v) => ({
    value: v,
    label: describeRepairability(v),
  }),
);

export function ClaimsItemRepairabilityDropdown(
  props: ItemRepairabilityDropdownProps,
) {
  const { repairability, setRepairability, id } = props;
  return (
    <Dropdown
      data-testid={id || "item-repairability-dropdown"}
      value={repairability}
      onChange={(v) => setRepairability(v as FreightClaimRepairability)}
      options={repairabilityOptions}
      width={claimsFieldWidth.token}
    />
  );
}
